import HttpRequest from '@/libs/axios';

let baseUrl = process.env.VUE_APP_API_URL as string;
let wsHttpUrl = process.env.VUE_APP_WS_HTTP_URL as string;
let logHttpUrl = process.env.VUE_APP_LOG_API_URL as string;
let logHttpUrl_V2 = process.env.VUE_APP_LOG_API_V2_URL as string;

const hrefName: string = window.location.origin;
const href: string = window.location.href;
if (hrefName.includes('https://app') || hrefName.includes('http://app')) {
    baseUrl = `${hrefName.replace('app', 'api')}/`;
    wsHttpUrl = `${hrefName.replace('app', 'msg')}/`;
    if (href.indexOf('mvtest=nginx') > -1) {
        wsHttpUrl = `${hrefName.replace('app', 'msg-nginx')}/`;
    }
}

if (!logHttpUrl) {
    logHttpUrl = baseUrl;
}
if (!logHttpUrl_V2) {
    logHttpUrl_V2 = baseUrl;
}

export const reqUrl = baseUrl;
export const axios = new HttpRequest(baseUrl);
export const reqWsUrl = wsHttpUrl;
export const axiosWs = new HttpRequest(wsHttpUrl, 'ws');

export const axiosLog = new HttpRequest(logHttpUrl, 'log');
export const axiosLog_V2 = new HttpRequest(logHttpUrl_V2, 'log');

interface Params {
    [key: string]: string;
}
interface ExportParams {
    method?: string;
    url: string;
    params: Params;
}
export const exportAction = ({
    method,
    url,
    params,
}: ExportParams) => {
    const form = document.createElement('form');
    form.id = 'exportForm';
    form.name = 'exportForm';
    form.target = '_blank';
    form.method = method ? method.toLocaleUpperCase() : 'GET';
    form.action = `${baseUrl}${url}`;
    document.body.appendChild(form);
    // 加参
    if (params) {
        Object.keys(params).map((key: string) => {
            const input = document.createElement('input');
            input.id = key;
            input.name = key;
            input.value = typeof params[key] === 'object' ? JSON.stringify(params[key]) : params[key];
            form.appendChild(input);
            return key;
        });
    }
    // 触发submit
    form.submit();
    // 删除该 form
    document.body.removeChild(form);
};
